import { addMessages } from '@hana/i18n';

// Chuỗi khung Tổng quan Job. Mã nghiệp vụ, tên riêng, dữ liệu mẫu không dịch.
addMessages('vi', {
  'ov.unread': 'chưa đọc',
  'ov.plan': "Kế hoạch vận chuyển",
  'ov.status': "Trạng thái",
  'ov.latest': "Gần nhất",
  'ov.next': "Kế tiếp",
  'ov.vesselProfile': "Hồ sơ tàu",
  'ov.milestones': "Mốc nội bộ của job",
  'ov.filterParty': "Lọc theo bên",
  'ov.filterActivity': "Lọc hoạt động",
  'ov.jobAlerts': "Cảnh báo của job",
  'ov.manage': "Quản lý",
  'ov.togglePlanWhy': "Mở hoặc gập lý do thay đổi kế hoạch",
  'ov.editRoute': "Sửa và thao tác tuyến tàu",
  'ov.viewMail': "Xem thư",
  'ov.toggle': "Mở hoặc gập",
  'ov.copy': "Chép",
  'ov.mailFlow': "Luồng mail",
  'ov.recentActivity': "Hoạt động gần đây",
  'ov.bookingRefs': "Booking & tham chiếu",
  'ov.customs': "Hải quan",
  'ov.alerts': "Cảnh báo",
  'ov.todo': "Việc cần làm",
  'ov.mainInfo': "Thông tin chính",
  'ov.pic': "Người phụ trách",
  'ov.jobGroup': "Nhóm job",
  'ov.closeJob': "Đóng job",
  'ov.mailDone': "Đã xử lý",
  'ov.mailWait': "Chờ xử lý",
  'ov.overSla': "Quá SLA",
  'ov.seeMore': "Xem thêm {n}",
  'ov.maybeRelated': "Có thể liên quan · {n}",
  'ov.nThreads': "{n} luồng",
  'ov.nUnread': "{n} chưa đọc",
  'ov.nOverSla': "{n} quá SLA",
  'ov.nAuto': "{n} tự gắn",
  'ov.nAtt': "{n} tệp đính kèm",
  'ov.nInThread': "{n} thư trong luồng",
  'ov.copied': "Đã chép {label}",
});
addMessages('en', {
  'ov.unread': 'unread',
  'ov.plan': "Shipping plan",
  'ov.status': "Status",
  'ov.latest': "Latest",
  'ov.next': "Next",
  'ov.vesselProfile': "Vessel profile",
  'ov.milestones': "Job internal milestones",
  'ov.filterParty': "Filter by party",
  'ov.filterActivity': "Filter activity",
  'ov.jobAlerts': "Job alerts",
  'ov.manage': "Manage",
  'ov.togglePlanWhy': "Expand or collapse plan change reason",
  'ov.editRoute': "Edit and route actions",
  'ov.viewMail': "View mail",
  'ov.toggle': "Expand or collapse",
  'ov.copy': "Copy",
  'ov.mailFlow': "Mail threads",
  'ov.recentActivity': "Recent activity",
  'ov.bookingRefs': "Booking & references",
  'ov.customs': "Customs",
  'ov.alerts': "Alerts",
  'ov.todo': "To do",
  'ov.mainInfo': "Key information",
  'ov.pic': "Person in charge",
  'ov.jobGroup': "Job group",
  'ov.closeJob': "Close job",
  'ov.mailDone': "Handled",
  'ov.mailWait': "Pending",
  'ov.overSla': "Over SLA",
  'ov.seeMore': "See {n} more",
  'ov.maybeRelated': "Possibly related · {n}",
  'ov.nThreads': "{n} threads",
  'ov.nUnread': "{n} unread",
  'ov.nOverSla': "{n} over SLA",
  'ov.nAuto': "{n} auto-linked",
  'ov.nAtt': "{n} attachments",
  'ov.nInThread': "{n} messages in thread",
  'ov.copied': "Copied {label}",
});

addMessages('vi', {
  'overview.a11y1': 'Giải thích: Chỉ dùng dữ liệu app có: lịch tàu và booking (ETD, ETA, tàu, chuyến), mốc nội bộ do người dùng cập nhật hoặc lấy từ chứng từ. Không theo dõi sự kiện cảng.',
  'overview.a11y2': 'Chỉ dùng dữ liệu app có: lịch tàu và booking (ETD, ETA, tàu, chuyến), mốc nội bộ do người dùng cập nhật hoặc lấy từ chứng từ. Không theo dõi sự kiện cảng.',
  'overview.a11y3': 'Transit = ETA − ETD theo lịch tàu hãng (cảng tới cảng)',
  'overview.a11y4': 'Luật hạn: Draft B/L khách duyệt trong 24h kể từ lúc gửi',
  'overview.a11y5': 'Draft B/L khách duyệt trong 24h kể từ lúc gửi',
  'overview.a11y6': 'Giải thích: Thư chưa gắn job · Ask HANA đoán là của SE260637420 theo số booking hoặc số container trong tiêu đề và nội dung',
  'overview.a11y7': 'Thư chưa gắn job · Ask HANA đoán là của SE260637420 theo số booking hoặc số container trong tiêu đề và nội dung',
  'overview.a11y8': 'Memo khách SAVITA',
  'overview.a11y9': 'Mở nhóm chat của job SE260637420 trong HANA Hei',
  'overview.a11y10': 'Đủ 7 điều kiện mới gửi Kế toán khoá',
});
addMessages('en', {
  'overview.a11y1': 'Explanation: Only uses data the app has: vessel schedule and booking (ETD, ETA, vessel, voyage), internal milestones updated by users or taken from documents. No port event tracking.',
  'overview.a11y2': 'Only uses data the app has: vessel schedule and booking (ETD, ETA, vessel, voyage), internal milestones updated by users or taken from documents. No port event tracking.',
  'overview.a11y3': 'Transit = ETA − ETD per carrier schedule (port to port)',
  'overview.a11y4': 'Deadline rule: customer approves Draft B/L within 24h of sending',
  'overview.a11y5': 'Customer approves Draft B/L within 24h of sending',
  'overview.a11y6': 'Explanation: Mail not linked to a job · Ask HANA guesses it belongs to SE260637420 from the booking or container number in subject and body',
  'overview.a11y7': 'Mail not linked to a job · Ask HANA guesses it belongs to SE260637420 from the booking or container number in subject and body',
  'overview.a11y8': 'SAVITA customer memo',
  'overview.a11y9': 'Open the job SE260637420 chat group in HANA Hei',
  'overview.a11y10': 'All 7 conditions must be met before sending to Accounting lock',
});

addMessages('vi', {
  'ovx.gateIn': 'Hạ bãi YMLU 541 220-0 tại Cát Lái · 22/Oct 08:40',
  'ovx.cyCutoff': 'Cut-off CY tại Cát Lái · hạn nội bộ 23/Oct 17:30',
  'ovx.polAddr': 'Cát Lái, TP. Hồ Chí Minh, VN',
  'ovx.bind': 'Gắn',
  'ovx.add': 'Thêm',
  'ovx.edit': 'Sửa',
  'ovx.del': 'Xoá',
  'ovx.editJob': 'Sửa job',
  'ovx.create': 'Tạo',
  'ovx.logProg': 'Ghi tiến độ',
});

addMessages('en', {
  'ovx.gateIn': 'Gate-in YMLU 541 220-0 at Cat Lai · 22/Oct 08:40',
  'ovx.cyCutoff': 'CY cut-off at Cat Lai · internal deadline 23/Oct 17:30',
  'ovx.polAddr': 'Cat Lai, Ho Chi Minh City, VN',
  'ovx.bind': 'Attach',
  'ovx.add': 'Add',
  'ovx.edit': 'Edit',
  'ovx.del': 'Delete',
  'ovx.editJob': 'Edit job',
  'ovx.create': 'Create',
  'ovx.logProg': 'Log progress',
});
